export default {
  lang: {
    reset: 'Reseta',
    search: 'Filtral',
    expand: 'Lawak',
    collapse: 'Stow',
  },
};
